<!--v-on="$listeners"-->
<!--      :rules="[v => !!v || title], v => (v && v.length <= to && v.length>=from) || warning]"-->
<!--v-mask="getPlaceholder()"
masked="true"-->
<template>
  <v-text-field
      v-bind="$attrs"
      v-model="inputVal"
      :label="label"
      :rules="[v => (validateDecimal(v)) || getWarning()]"
      :counter="getLength()"
      :maxlength="getLength()"
      v-on:keyup.enter="focusNext($event.target)"
      :placeholder="getPlaceholder()"
      oninput="let p=this.selectionStart;this.value=this.value.replace(/[^0-9.]/, '');this.setSelectionRange(p, p);"
      color="primary"
  />
  <!--  :value="value"
    @input="v => $emit('input', v)"-->
</template>

<script>
/*inheritAttrs: true,*/

import {mask} from 'vue-the-mask';

/**
 * title: descripcion del input
 * **/
export default {
  name: "input-unsigned-decimal",
  props: ['value', 'label', 'integer', 'decimal'],
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  directives: {mask},
  data: () => ({
    getLength() {
      return this.integer + this.decimal + 1;
    },
    getTitle() {
      return `${this.label.replace(/\(\*\)/, '')} es obligatoria`;
    },
    getWarning() {
      return `${this.label.replace(/\(\*\)/, '')} debe contener hasta ${this.integer} enteros y ${this.decimal} decimales.`
    },
    getPlaceholder() {
      let placeholder = '';
      for (let i = 0; i < this.integer; i++) {
        placeholder += '0';
      }
      placeholder += '.';
      for (let i = 0; i < this.decimal; i++) {
        placeholder += '0';
      }
      return placeholder;
    },
    focusNext(elem) {
      const currentIndex = Array.from(elem.form.elements).indexOf(elem);
      elem.form.elements.item(
          currentIndex < elem.form.elements.length - 1 ?
              currentIndex + 1 :
              0
      ).focus();
    },
    validateDecimal(v) {
      return new RegExp('^(([0-9]{1,' + this.integer + '}\\.)([0-9]{' + this.decimal + '}))|([0-9]{1,' + this.integer + '})$').test(v);
    }
  })
}
</script>

<style scoped>

</style>